

























import {Component, Prop, Vue} from 'vue-property-decorator'
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";
import ParamProxy, {ProxyMode} from "@/module/thing/ParamProxy"
import ParamStdProxyFormItems from "@/component/Thing/param-std-proxy-form-items.vue";
import ParamBindProxyFormItems from "@/component/Thing/param-bind-proxy-form-items.vue";

@Component({
  components: {
    DataSpecsFormItems,
    ParamStdProxyFormItems,
    ParamBindProxyFormItems
  },
})
export default class EditParamDialog extends Vue {
  @Prop() title!: string
  @Prop() paramProxy!: ParamProxy

  isStdProxy() {
    return this.paramProxy.mode == ProxyMode.STD_PROXY
  }

  isBindProxy() {
    return this.paramProxy.mode == ProxyMode.BIND_PROXY
  }

  private visible = false

  open() {
    this.visible = true
  }

  close() {
    this.visible = false
  }

  confirm() {
    this.$emit('confirm', this.getParamProxy())
    this.close()
  }

  getParamProxy() {
    return this.paramProxy
  }
}
